import { request } from '@ui/api/v2/api';

export interface ICountry {
  id: number;
  name: string;
}

export interface IRegion {
  id: number;
  name: string;
  country: ICountry;
}

export interface ICreateRegion {
  name: string;
  country: string;
}

export function getRegions() {
  return request<{ regions: IRegion[] }>('get', 'region/regions');
}

export function createRegion(region: ICreateRegion) {
  return request<IRegion>('post', 'region', { region });
}

export function updateRegion(id: number, region: ICreateRegion) {
  return request('patch', `region/${id}`, { region });
}

export function deleteRegion(id: number) {
  return request('delete', `region/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/v2/regions.api.ts